<div class="wrapper">
  <div class="container center">
    <svg-icon src="./assets/illustrations/{{ state.illustration }}.svg" class="wg-illustration primary mb-xl"></svg-icon>
    <h1 class="wg-h-md">{{ state.titleText | translate }}</h1>
    <p innerHtml="{{ state.descriptionText | translate }}"></p>
  </div>
  <div class="container">
    <section *ngIf="state.showResetLink">
      <p>{{ 'SuspendPage.linkLabel' | translate }}</p>
      <ion-button size="large" fill="clear" [disabled]="!isOnline" (click)="reset()">{{ 'SuspendPage.resetLink' | translate }}</ion-button>
    </section>
    <section [hidden]="!isCurrent">
      <ion-button size="large" fill="clear" (click)="skip()" *ngIf="state.showSkipBtn">{{ 'OptionalPage.later' | translate }}</ion-button>
      <ion-button size="large" (click)="next()" [disabled]="isNextBtnDisabled" *ngIf="state.showNextBtn">{{
        state.nextBtnText | translate
      }}</ion-button>
    </section>
  </div>
</div>
